import { paymentOrderUIModel } from "src/store/models/ui/payment/paymentOrder";
import { paymentProductUIModel } from "src/store/models/ui/payment/paymentProduct";

export const encooPaymentUIModels = {
  product: paymentProductUIModel,
  order: paymentOrderUIModel,
};
